<template>
    <div id="plans-detail">
        <!--=====================================-->
        <!--=       INTERES COMPUESTO           =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle bold primary">Planes de Inversión</span>
                    <h2 class="title">Interés <span class="bold">compuesto.</span></h2>
                </div>
                <div class="axil-isotope-wrapper">
                    <div class="row row-35 isotope-list">
                        <div class="col-md-6 col-lg-4 col-sm-12 project branding">
                            <div class="project-grid">
                                <div class="thumbnail">
                                    <img :src="`${baseLogo}interes-compuesto.png`" alt="interes-compuesto">
                                </div>
                                <div class="content">
                                    <h4 class="title bold">Inversión automática</h4>
                                    <span class="subtitle">Reinvierte el 100% de los pagos 
                                        que recibas para generar 
                                        interés sobre interés.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 col-sm-12 project mobile">
                            <div class="project-grid">
                                <div class="thumbnail">
                                    <img :src="`${baseLogo}abono-recurrente.png`" alt="abono-recurrente">
                                </div>
                                <div class="content">
                                    <h4 class="title bold">Abono recurrente</h4>
                                    <span class="subtitle">Domicilia tu cuenta de banco, elige el día y monto que desees abonar para crecer consistentemente tu portafolio.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--=====================================-->
        <!--=       INGRESO PASIVO              =-->
        <!--=====================================-->
        <section class="section mb--80">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle bold primary">Planes de Inversión</span>
                    <h2 class="title">Ingreso <span class="bold">pasivo.</span></h2>
                </div>
                <div class="axil-isotope-wrapper">
                    <div class="row row-35 isotope-list">
                        <div class="col-md-6 col-lg-4 col-sm-12 project branding">
                            <div class="project-grid">
                                <div class="thumbnail">
                                    <img :src="`${baseLogo}ingreso-pasivo.png`" alt="ingreso-pasico">
                                </div>
                                <div class="content">
                                    <h4 class="title bold">Ingreso pasivo</h4>
                                    <span class="subtitle">Mantén una inversión fija y retira 
                                        el excedente para crear 
                                        un ingreso pasivo.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 col-sm-12 project mobile">
                            <div class="project-grid">
                                <div class="thumbnail">
                                    <img :src="`${baseLogo}retiro-recurrente.png`" alt="retiro-recurrente">
                                </div>
                                <div class="content">
                                    <h4 class="title bold">Retiro recurrente</h4>
                                    <span class="subtitle">Define el día y banco al cual quieres 
                                        retirar mes a mes tu ingreso pasivo.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "PlansDetail",
        components: {
        },
        data() {
            return {
                baseLogo: "https://cdn.redgirasol.com/nuevo_portal/logos/investors/logo-"
            }
        }
    }
</script>